import React from 'react';

import {ScreenshotGuest} from "./ScreenshotGuest";
import { Card, Modal, Text, Group, ActionIcon } from '@mantine/core';
import { IconX, IconUserCircle } from '@tabler/icons-react';
import { editorModalShell } from "../styleFile";

export default function ScreenshotModal({cameraGuest, artboard, name, closeMaximisedClick, id}) {

  return (
    <Modal
      opened={true}
      onClose={closeMaximisedClick}
      centered
      withCloseButton={false}
      size="80%"
      radius={editorModalShell.radius}
      overlayProps={editorModalShell.overlayProps}
      styles={{
        ...editorModalShell.styles,
        body: { padding: 0, position: "relative", minHeight: 420 },
      }}
    >
      <Card
        radius={6}
        p={0}
        withBorder={false}
        shadow="none"
        style={{
          width: "100%",
          height: "min(70vh, 640px)",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <ScreenshotGuest cameraGuest={cameraGuest} artboard={artboard} id={id} />
        <Group
          justify="space-between"
          align="center"
          gap="sm"
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            padding: "8px 16px",
            backgroundColor: "var(--mbx-modal-standard-fill, #ffffff)",
            borderTop: "1px solid var(--mbx-modal-border, #e7e5e4)",
            height: 40,
          }}
        >
          <Group gap={6} wrap="nowrap">
            <IconUserCircle size={18} />
            <Text size="sm" fw={500}>
              {name} | {artboard}
            </Text>
          </Group>
          <ActionIcon variant="subtle" color="gray" onClick={closeMaximisedClick} aria-label="Close">
            <IconX size={18} />
          </ActionIcon>
        </Group>
      </Card>
    </Modal>
  );
}
